export const name = 'expandableMenu' as const
